const competencies = [
  'Постановка задач',
  'Делегирование',
  'Контроль',
  'Обратная связь',
  'Мотивация',
  'Развитие сотрудников',
  'Управление конфликтами',
  'Принятие решений',
  'Коммуникация',
  'Управление изменениями',
];

export default function SpecialistToManager() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-6">
              Почему профессионал не всегда становится хорошим руководителем
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-5">
              Это одна из самых распространённых проблем в компаниях. Лучшего специалиста повышают до руководителя — и компания теряет сильного исполнителя, не получая эффективного управленца. Дело не в сотруднике. Дело в том, что управленческая работа принципиально отличается от работы специалиста.
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-5">
              Специалист отвечает прежде всего за <strong>собственный результат</strong>. Его успех зависит от его знаний, навыков и усилий. Когда он становится руководителем, природа его работы меняется: теперь он отвечает за <strong>результат других людей</strong>. А для этого нужны совершенно другие компетенции.
            </p>
            <p className="text-base text-gray-600 leading-relaxed">
              Хороший продавец не обязательно станет хорошим руководителем отдела продаж. Сильный разработчик не обязательно станет эффективным тимлидом. Потому что управление — это отдельная профессия, которой нужно учиться так же системно, как и любой другой.
            </p>
          </div>

          <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-xl font-bold text-gray-900 mb-5">
              Какие компетенции необходимы руководителю
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {competencies.map((comp, i) => (
                <div key={i} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-teal-700"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-800">{comp}</span>
                </div>
              ))}
            </div>
            <p className="text-sm text-gray-500 mt-6 leading-relaxed">
              Это не просто «полезные навыки». Без них руководитель не сможет эффективно управлять командой, какой бы сильной ни была его профессиональная экспертиза.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}